/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BrandResponse } from '../models/BrandResponse';
import type { CreateBrandDto } from '../models/CreateBrandDto';
import type { DeletedResponse } from '../models/DeletedResponse';
import type { UpdateBrandDto } from '../models/UpdateBrandDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class BrandsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * List all brands
     * Returns a paginated list of brands with optional filters for category, enabled status, and search.
     * @returns any Brands returned successfully.
     * @throws ApiError
     */
    public brandsControllerFindAll({
        page = 1,
        limit = 50,
        category,
        enabled,
        search,
        sortBy = 'label',
        sortOrder = 'asc',
    }: {
        /**
         * Page number
         */
        page?: number,
        /**
         * Items per page
         */
        limit?: number,
        /**
         * Filter by category
         */
        category?: 'ALARME_INTRUSION' | 'VIDEO_SURVEILLANCE' | 'CONTROLE_D_ACCES' | 'DOMOTIQUE' | 'ALARME_INCENDIE',
        /**
         * Filter by enabled status
         */
        enabled?: boolean,
        /**
         * Search by label
         */
        search?: string,
        /**
         * Sort field
         */
        sortBy?: 'label' | 'category' | 'createdAt',
        /**
         * Sort order
         */
        sortOrder?: 'asc' | 'desc',
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/brands',
            query: {
                'page': page,
                'limit': limit,
                'category': category,
                'enabled': enabled,
                'search': search,
                'sortBy': sortBy,
                'sortOrder': sortOrder,
            },
            errors: {
                401: `Unauthorized.`,
            },
        });
    }
    /**
     * Create a brand (admin)
     * Creates a new brand. Admin only.
     * @returns BrandResponse Brand created successfully.
     * @throws ApiError
     */
    public brandsControllerCreate({
        requestBody,
    }: {
        requestBody: CreateBrandDto,
    }): CancelablePromise<BrandResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/brands',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error.`,
                401: `Unauthorized.`,
                403: `Forbidden. ADMIN role required.`,
                409: `Brand with this label already exists in the category.`,
            },
        });
    }
    /**
     * List enabled brands grouped by category
     * Returns all enabled brands grouped by their category. Used for dropdowns and selection UIs.
     * @returns any Brands grouped by category returned successfully.
     * @throws ApiError
     */
    public brandsControllerFindAllByCategory(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/brands/by-category',
            errors: {
                401: `Unauthorized.`,
            },
        });
    }
    /**
     * Get brand by ID
     * Returns a single brand by its unique identifier.
     * @returns BrandResponse Brand found.
     * @throws ApiError
     */
    public brandsControllerFindOne({
        id,
    }: {
        /**
         * Brand unique identifier
         */
        id: string,
    }): CancelablePromise<BrandResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/brands/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized.`,
                404: `Brand not found.`,
            },
        });
    }
    /**
     * Update a brand (admin)
     * Updates an existing brand. Admin only.
     * @returns BrandResponse Brand updated successfully.
     * @throws ApiError
     */
    public brandsControllerUpdate({
        id,
        requestBody,
    }: {
        /**
         * Brand unique identifier
         */
        id: string,
        requestBody: UpdateBrandDto,
    }): CancelablePromise<BrandResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/brands/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error.`,
                401: `Unauthorized.`,
                403: `Forbidden. ADMIN role required.`,
                404: `Brand not found.`,
                409: `Brand with this label already exists in the category.`,
            },
        });
    }
    /**
     * Delete a brand (admin)
     * Deletes a brand. Admin only.
     * @returns DeletedResponse Brand deleted successfully.
     * @throws ApiError
     */
    public brandsControllerRemove({
        id,
    }: {
        /**
         * Brand unique identifier
         */
        id: string,
    }): CancelablePromise<DeletedResponse> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/brands/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. ADMIN role required.`,
                404: `Brand not found.`,
            },
        });
    }
}
